var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelect',{ref:"select",attrs:{"value":_vm.mailbox,"options":_vm.mailboxes,"required":true},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }